import { getDesignStudioCalendlyLink } from '@/lib/contentstack-sdk';
import { getPromosByLocation } from '@/lib/data/getPromosByLocation';
import { getStudioModelHomes } from '@/lib/data/getStudioModelHomes';
import { TmDesignCenterDetails } from './tm-design-center-detail';
import { ITmDesignCenterDetailsCSProps } from './tm-design-center-details.types';
import { getCachedInitialProps } from '@/components/helpers/fetchInitialProps';

export async function TmDesignCenterDetailCMS({
  block,
}: {
  block: ITmDesignCenterDetailsCSProps;
}) {
  const studioId = block?.studio_id?.location?.[0];
  const { studio3DData, studioData: allStudios } =
    await getCachedInitialProps();
  const modelHomes = await getStudioModelHomes(Number(studioId));
  const calendlyLink = await getDesignStudioCalendlyLink(
    Number(studioId),
    studio3DData,
  );
  const promos = await getPromosByLocation(Number(studioId));
  const studio = allStudios.find((s) => s.Id === Number(studioId));

  return (
    <TmDesignCenterDetails
      block={block}
      modelHomeData={modelHomes}
      calendlyLink={calendlyLink}
      promotions={promos}
      pageStudio={studio}
    />
  );
}
